import axios from "axios";
import { authHeader } from "@/lib/auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createEnquiry = async (payload) => {
  const { data } = await axios.post(`${API}/enquiries`, payload);
  return data;
};

export const listEnquiries = async () => {
  const { data } = await axios.get(`${API}/enquiries`, { headers: authHeader() });
  return data;
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};
